import { render, staticRenderFns } from "./PercentAndPeriodRateWidgetWithoutStore.vue?vue&type=template&id=a2818452&"
import script from "./PercentAndPeriodRateWidgetWithoutStore.vue?vue&type=script&lang=js&"
export * from "./PercentAndPeriodRateWidgetWithoutStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports